import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import anime from "animejs";
import { swiperInit } from './swiper';
import { recruitInit } from './page-recruit';
import { blackscreenInit } from './Blackscreen';
import { accInit } from './acc';
import { onclicksInit } from './onclicks';
import { sidebarInit } from './Sidebard';
import { getTolerance, movetoInit } from './moveto';
import { SMInit } from './scrollmagic';
import { splashInit } from './splash';
import { modalvideoInit } from './modalvideo';

window.barbaInfo = { move: 0 }

//header・body書き換え
const replaceHead = function (data) {
    const head = document.head;
    const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    const removeHeadTags = [
        "meta[name='keywords']", "meta[name='description']", "meta[property^='og']", "meta[name^='twitter']", "meta[itemprop]", "link[itemprop]", "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"
    ].join(',');

    const headTags = head.querySelectorAll(removeHeadTags)

    for (let i = 0; i < headTags.length; i++) {
        head.removeChild(headTags[i]);
    }

    const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for (let i = 0; i < newHeadTags.length; i++) {
        head.appendChild(newHeadTags[i]);
    }

    //bodyクラス変更
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
        match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "");
    } else {
        // Set the new body class
        document.body.setAttribute("class", match[1]);
    }
}

// ページ遷移時に実行する内容
function everyMove() {
    try {
        window.barbaInfo.move++
        splashInit()
        swiperInit()
        movetoInit()
        recruitInit(window.barbaInfo.move)
        blackscreenInit()
        accInit()
        onclicksInit()
        sidebarInit(window.barbaInfo.move)
        SMInit()
        modalvideoInit()
        if (location.hash != "") {
            setTimeout(() => {
                let offset = getTolerance().tolerance + getTolerance().offset
                if (innerWidth <= 1024) {
                    // offset = 0
                }
                let scrollvalue = document.querySelector(location.hash).getBoundingClientRect().top - offset
                // console.log(String(document.querySelector(location.hash).getBoundingClientRect().top) + " " + offset + " " + scrollvalue)
                window.scrollTo({
                    top: scrollvalue
                })
            }, 10)
        }
    } catch (e) {
        console.warn(e)
    }
}

everyMove()

barba.hooks.before((data) => { })

barba.hooks.enter((data) => {
    document.body.classList.remove("loading")
})

barba.hooks.after((data) => {
    replaceHead(data);
    everyMove(data)
})

barba.use(barbaPrefetch);

let wrapper = document.querySelector(".wrapper")

let leaveT = 500,
    enterT = 500

barba.init({
    timeout: 5000,
    transitions: [{
        name: 'page-transition',
        sync: true,
        leave: function (data) {
            const done = this.async();
            data.current.container.classList.add("js-barba__leave");
            wrapper.classList.add("js-barba__leave");

            anime.timeline().add({
                targets: [data.current.container],
                opacity: [1, 0],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: leaveT,
                begin: () => {

                },
                complete: () => {
                    data.current.container.classList.remove("js-barba__leave");
                    wrapper.classList.remove("js-barba__leave");
                    done()
                    if (data.trigger != "back" && data.trigger != "forward") {
                        window.scrollTo(0, 0)
                    }
                }
            })
        },
        enter: function (data) {
            const done = this.async();
            data.next.container.classList.add("js-barba__enter");
            wrapper.classList.add("js-barba__enter");

            anime.timeline().add({
                targets: [data.next.container],
                opacity: [0, 1],
                top: ["100px", "0px"],
                easing: "cubicBezier(.17,.67,.48,.92)",
                delay: leaveT,
                duration: enterT,
                begin: () => {
                    done();
                },
                complete: () => {
                    data.next.container.classList.remove("js-barba__enter");
                    wrapper.classList.remove("js-barba__enter");
                }
            })
        }
    }],
})